import { MinusIcon, PlusIcon } from '@heroicons/react/24/solid';

import Button from '@/components/Button/Button';

import { Product } from '../../types/product';

import styles from './styles.module.scss';

interface ProductButtonProps {
  product: Product;
  isProductSold: boolean;
  handleSubtractQty: () => void;
  selectedQuantity: number;
  stockQuantity: number;
  handleAddQty: () => void;
  handleAddToCart: () => void;
}

/**
 * `FEATURE`: Button that adds product to cart
 * @param props
 * @returns
 */
export const ProductButton = (props: ProductButtonProps) => {
  const {
    product,
    isProductSold,
    handleAddQty,
    handleAddToCart,
    handleSubtractQty,
    selectedQuantity,
    stockQuantity,
  } = props;

  const { category, subcategory } = product;

  if (isProductSold) {
    let similarPorductsHref = `/k/${category.handle}/${subcategory.handle}/`;
    if (subcategory.absolute_path) {
      similarPorductsHref = `/k/${subcategory.absolute_path}`;
    }
    return (
      <Button
        href={similarPorductsHref}
        variant="primary"
        fullWidth
        isBiggerPadding
        isOutline
      >
        Zobacz podobne produkty
      </Button>
    );
  }

  return (
    <div className={styles.addToCartSection}>
      <div
        className={`${styles.quantitySelect} ${
          stockQuantity <= 1 ? styles.hidden : ''
        }`}
      >
        <Button
          variant="icon"
          onClick={handleSubtractQty}
          disabled={selectedQuantity <= 1}
        >
          <MinusIcon width={20} />
        </Button>
        <span className={styles.qty}>
          {stockQuantity < selectedQuantity ? stockQuantity : selectedQuantity}
        </span>
        <Button
          variant="icon"
          onClick={handleAddQty}
          disabled={selectedQuantity >= stockQuantity}
        >
          <PlusIcon width={20} />
        </Button>
      </div>
      <div
        className={`${styles.addToCartBtn} ${
          stockQuantity <= 1 ? styles.addToCartBtnBig : ''
        }`}
      >
        <Button
          variant="checkout"
          fullWidth
          isBiggerPadding
          onClick={handleAddToCart}
          disabled={isProductSold || stockQuantity === 0}
        >
          Dodaj do koszyka
        </Button>
      </div>
    </div>
  );
};
